import fetch from "@lib/fetch";

import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { cortexAgentRunQuery } from "./constants";
import type { PostwsCortexAgentRunQueryPayload, PostwsCortexAgentRunQueryProps } from "./types";
import { isCortexAgentRunQueryAsyncResult } from "./validators";

export const postwsCortexAgentRunQuery = reactQueryPostWebsocketAdapter(
  cortexAgentRunQuery,
  async (signal, { query, jobToken }: PostwsCortexAgentRunQueryProps): Promise<{}> => {
    const payload: PostwsCortexAgentRunQueryPayload = {
      job_token: jobToken,
      query,
    };

    return await fetch("/cortex_agent/run_query", "POST", payload, { signal });
  },
  isCortexAgentRunQueryAsyncResult
);
